// extracted by mini-css-extract-plugin
export default {"questions":"css_questions__AngzV"};